import toDate from '../to-date';

export const getMinutes = (date: Date | number): number => {
  const formattedDate = toDate(date);

  const hours = formattedDate.getMinutes();

  return hours;
};

export default getMinutes;
